<template>
  <div :class="theme ? 'theme-background-bg' : ''">
    <div class="Header" :class="{ 'no-index': $route.path != '/index' }">
      <div class="header-content">
        <div class="logo" @click="$router.push('/index')">
          <img src="@/assets/images/land-logo.png" alt="" />
          <span>开放云书院</span>
        </div>
        <div class="header-right">
          <div class="nav">
            <el-menu :default-active="getActive" class="el-menu-demo" mode="horizontal" @select="handleSelect"
              text-color="#fff" router>
              <el-menu-item index="index" :route="{ path: '/index' }">首页</el-menu-item>
              <el-menu-item index="bookstore" :route="{ path: '/bookstore/index' }">学科分类</el-menu-item>
              <el-menu-item index="bookstore1" :route="{ path: '/bookstore/index?type=1' }">特色资源</el-menu-item>
              <el-menu-item index="bookstore2" :route="{ path: '/bookstore/index?type=2' }">精品项目</el-menu-item>
              <el-menu-item index="special" :route="{ path: '/special/index' }">专题</el-menu-item>
              <!--              <el-menu-item index="authorLibrary" :route="{ path: '/authorLibrary/index' }">作者库</el-menu-item>-->
              <!-- <el-menu-item @click="userFeedback('/resourceLibrary/index')"
                >资源库</el-menu-item
              > -->
              <!--              <el-menu-item index="coagency" :route="{ path: '/coagency/index' }">合作机构</el-menu-item>-->

              <!-- <el-menu-item index="coagency"></el-menu-item> -->
              <el-menu-item>
                <el-dropdown>
                  <span class="el-dropdown-link">资源库<i class="el-icon-arrow-down el-icon--right"
                      style="color: #ffffff"></i></span>
                  <el-dropdown-menu slot="dropdown">
                    <li class="el-dropdown-menu__item" @click="userFeedback('/Lib/gx')">
                      广西职业技术学院
                    </li>
                  </el-dropdown-menu>
                </el-dropdown>
              </el-menu-item>
              <el-menu-item index="willingLearn" :route="{ path: '/willingLearn/index/index' }">
                <el-dropdown>
                  <span class="el-dropdown-link">{{ classifyName
                  }}<i class="el-icon-arrow-down el-icon--right" style="color: #ffffff"></i></span>
                  <el-dropdown-menu slot="dropdown">
                    <li v-for="(item, index) in classifyList" :key="index" class="el-dropdown-menu__item"
                      :style="classifyIndex == index ? 'color:#2E9ADB;' : ''" @click="toIndex(item.id, index)">
                      {{ item.label }}
                    </li>
                  </el-dropdown-menu>
                </el-dropdown>
              </el-menu-item>
            </el-menu>
          </div>
          <div class="xml-right-function-box">
            <span @click="$router.push('/download')">下载</span>
            <span>|</span>
            <span @click="$router.push('/user/myResources')">书架</span>
            <router-link to="/cart/index">
              <el-badge :value="getCartNum" :hidden="getCartNum === 0" :max="99" class="item">
                <img src="@/assets/icon/buy-cart.png" alt="" />
              </el-badge>
            </router-link>
          </div>
          <div v-if="!$store.getters.token" class="xml-right-function-box" style="margin-left: 20px">
            <span @click="$router.push('/login')">登录</span>
            <span>/</span>
            <span @click="$router.push('/register')">注册</span>
          </div>
          <el-dropdown v-if="$store.getters.token" size="small" @command="handleCommand">
            <div class="user">
              <img @click="$router.push('/user/accountManage')" :src="avatar" class="avatar" alt="" />
              <span class="user-name">{{ name }}</span>
              <img src="@/assets/icon/down-arrow.png" class="arrow" alt="" />
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="个人中心">个人中心</el-dropdown-item>
              <el-dropdown-item command="退出登录">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getConfigKey } from "@/api/index/index.js";
import { GetTreeSelectByType } from "@/api/willingLearn/index.js";
export default {
  name: "Header",
  data() {
    return {
      theme: false,
      classifyList: [],
      classifyIndex: -1,
      classifyName: "国开乐学",
    };
  },
  created() {
    this.getConfig();
    this.getTreeType();
  },
  computed: {
    ...mapGetters(["name", "avatar", "getCartNum"]),
    getActive: function () {
      //让当前路由与子路由有相同的一个路径，然后通过计算属性拿到那个共有的路径，从而实现跳转到子路由导航菜单选项也高亮
      var path = this.$route.path.split("/");
      if (path[1] == "bookstore" && this.$route.query.type) {
        return path[1] + this.$route.query.type;
      }
      return path[1];
    },
  },
  watch: {
    "$route.path": function value(val) {
      // console.log(val);
    },
  },
  methods: {
    //首页置灰
    getConfig() {
      getConfigKey().then((res) => {
        this.UpTheme(res.data);
      });
    },
    UpTheme(data) {
      if (data == 0) {
        this.theme = true;
      } else {
        this.theme = false;
      }
    },
    handleSelect(key) {
      if (key != "willingLearn") {
        this.classifyIndex = -1;
      } else {
        this.classifyIndex = 0;
      }
    },
    handleCommand(a) {
      if (a === "个人中心") {
        this.$router.push({ path: "/user/index" });
      } else if (a === "退出登录") {
        this.$store.dispatch("LogOut").then(() => {
          this.$router.push("/index");
        });
      }
    },

    // 乐学下拉列表
    getTreeType() {
      let data = {
        catalogType: "train_property",
      };
      GetTreeSelectByType(data).then((res) => {
        let list = res.data;
        list.unshift({
          id: null,
          label: "全部图书分类",
        });
        if (this.classifyList.length == 0) {
          this.classifyList = list;
        }
      });
    },
    // 乐学列表点击进首页
    toIndex(id, index) {
      this.classifyIndex = index;
      this.$router.push({
        path: "/willingLearn/index/index",
        query: {
          id: id,
        },
      });
    },

    // 路由跳转新界面
    userFeedback(path) {
      // this.$router.push({ path: '/feedback' });
      // 用push,也能实现跳转，但是不能打开新页面。
      const { href } = this.$router.resolve({
        path,
      });
      window.open(href, "_blank");
    },
  },
};
</script>

<style scoped lang="scss">
.Header {
  width: 100%;
  height: 80px;
  background-color: rgba(0, 0, 0, 0.05);
  min-width: 1400px;
  //background: #1e5596;
  // opacity: 0.9;
  position: absolute;
  z-index: 1;

  &.no-index {
    position: static;
    background-image: url("../assets/images/header-bg.png");
    background-size: 100% 100%;
  }

  .header-content {
    min-width: 1400px;
    max-width: 1410px;
    height: 80px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    .logo {
      display: flex;
      flex-direction: row;
      align-items: center;
      height: 30px;
      cursor: pointer;

      img {
        width: 57px;
        height: 57px;
        margin-right: 10px;
      }

      span {
        font-size: 22px;
        font-family: Adobe Heiti Std;
        font-weight: normal;
        color: #ffffff;
      }
    }

    .header-right {
      height: 70px;
      display: flex;
      flex-direction: row;
      align-items: center;

      .nav {
        height: 70px;

        ul {
          height: 70px;
          display: flex;
          flex-direction: row;
          align-items: center;

          li {
            float: left;
            /* margin-right: 36px; */
            line-height: 70px;
            height: 70px;
            cursor: pointer;
            font-size: 22px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #ffffff;
            text-decoration: none;
            // a {
            // }
          }

          .active {

            // border-bottom: 2px solid #1e5596;
            a {
              font-size: 18px;
              font-family: PingFang SC;
              font-weight: bold;
              color: #ffffff;
            }
          }
        }

        span {
          float: left;
          /* margin-right: 36px; */
          line-height: 70px;
          height: 70px;
          cursor: pointer;
          font-size: 22px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #ffffff;
          text-decoration: none;
        }

        .classifyChange {
          color: red !important;
        }
      }

      .xml-right-function-box {
        display: flex;
        flex-direction: row;
        align-items: center;

        span {
          margin-right: 10px;
          cursor: pointer;
          font-size: 22px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #ffffff;
        }

        img {
          margin-left: 15px;
          width: 18px;
          height: 18px;
        }
      }

      .user {
        margin-left: 36px;
        display: flex;
        flex-direction: row;
        align-items: center;

        .avatar {
          width: 48px;
          height: 48px;
          border-radius: 50%;
          margin-right: 10px;
          cursor: pointer;
        }

        .user-name {
          display: block;
          max-width: 110px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: #fff;
          margin-right: 9px;
        }

        .arrow {
          width: 12px;
          height: 7px;
          cursor: pointer;
        }
      }
    }
  }
}

.el-menu {
  background-color: transparent;
}

.el-menu-item {
  &:hover {
    background-color: transparent !important;
  }
}

.el-menu--horizontal {
  .el-menu-item {
    color: #ffffff;
    font-size: 22px;
    font-family: PingFang SC;
    font-weight: 400;
  }

  .el-menu-item.is-active {
    border-bottom: none !important;
    font-family: PingFang SC !important;
    font-weight: bold !important;
    color: #ffffff !important;
  }
}

.el-menu.el-menu--horizontal {
  border-bottom: solid 0px #1e5596;
}
</style>

<style lang="scss">
.xml-right-function-box {
  .el-badge__content {
    .is-fixed {
      top: -3px;
      right: 5px;
      height: 16px;
      line-height: 15px;
      padding: 0 5px;
    }
  }
}

.el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
  background-color: transparent ;
}
</style>
